// src/redux/mapconfigSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {BASE_URL} from '../commonConfig/ApiConfig'

// Thunk for API call
export const fetchMapConfig = createAsyncThunk(
  'mapconfig/fetchMapConfig',
  async ({ selectedFeatures, typeIndicators, selectedTypeSubIndicators }, { rejectWithValue }) => {
    try {
      const payload = {
        lgd_code: selectedFeatures[0]?.properties?.parent_id,
        geo_level_code: selectedFeatures[0]?.properties?.parent_id,
        indicators: typeIndicators.map((ind, idx) => ({
          code: ind?.value,
          label: ind?.label,
          subIndicator: selectedTypeSubIndicators[idx]
            ? {
                code: selectedTypeSubIndicators[idx].value,
                label: selectedTypeSubIndicators[idx].label,
              }
            : {},
        })),
      };

      const response = await axios.post(
        `${BASE_URL}indicators/values`,
        payload
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const mapconfigApiSlice = createSlice({
  name: 'mapconfig',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchMapConfig.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMapConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchMapConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Error fetching map config';
      });
  },
});

export default mapconfigApiSlice.reducer;
